import { render, staticRenderFns } from "./VotingMode.vue?vue&type=template&id=736986d2&"
import script from "./VotingMode.vue?vue&type=script&lang=js&"
export * from "./VotingMode.vue?vue&type=script&lang=js&"
import style0 from "./VotingMode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VFlex,VIcon,VLayout,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736986d2')) {
      api.createRecord('736986d2', component.options)
    } else {
      api.reload('736986d2', component.options)
    }
    module.hot.accept("./VotingMode.vue?vue&type=template&id=736986d2&", function () {
      api.rerender('736986d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/GameModes/VotingMode.vue"
export default component.exports